function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames'; // import './index.less';
// 由于目前 svg 的 use 不能跨域，所以不建议使用外链形式的 svg sprite

function IconSvg(props) {
  // 获取传入的参数
  var name = props.name,
      url = props.url,
      className = props.className,
      children = props.children,
      inline = props.inline,
      extLink = props.extLink,
      rest = _objectWithoutProperties(props, ["name", "url", "className", "children", "inline", "extLink"]);

  var cssClass = classnames('iconsvg', className); // 如果有路径参数，则返回直接嵌入式代码

  if (children) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      viewBox: props.viewBox || '0 0 32 32',
      className: "".concat(cssClass, " iconsvg-").concat(name)
    }, rest), /*#__PURE__*/React.createElement("title", null, name), children);
  } // 传入 svg sprite url 地址参数，返回外链式代码
  // use 不能跨域，所以慎用


  if (url) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "".concat(cssClass, " iconsvg-").concat(name)
    }, rest), /*#__PURE__*/React.createElement("use", {
      xlinkHref: "".concat(url, "#icon-").concat(name)
    }));
  } // svg-loader
  // 直接 inline svg


  if (inline) {
    var attributes = name.attributes,
        content = name.content;
    return (
      /*#__PURE__*/

      /* eslint-disable */
      React.createElement("svg", _extends({
        className: "".concat(cssClass),
        dangerouslySetInnerHTML: {
          __html: content
        }
      }, attributes))
      /* eslint-enable */

    );
  } // svg-sprite-loader
  // inline svg，且把 svg 合并在一起插入到前面，使用的时候使用 use 根据 id 调用


  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "".concat(cssClass),
    viewBox: name.viewBox
  }, rest), /*#__PURE__*/React.createElement("use", {
    xlinkHref: extLink ? name.url : "#".concat(name.id)
  }));
}

IconSvg.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  className: PropTypes.string,

  /** 直接使用 svg sprite url，注意 use 不能跨域  */
  url: PropTypes.string,

  /** svg 自动转 react 组件，如果生成的 svg sprite 是外链请启用该参数，同样 use 不能跨域 */
  extLink: PropTypes.bool,

  /** 是否直接内嵌 svg，使用 svg-loader 加载 */
  inline: PropTypes.bool
};
export default IconSvg;